import React from "react";
import PageLayout from "../PageLayout";

const LoaderComponent = () => {
  return (
    <>
      <PageLayout>
        <div className="start">
          <div className="loader"></div>
          <p className="ending">Loading, please wait...</p>
        </div>
      </PageLayout>
    </>
  );
};

export default LoaderComponent;
